import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";
import { useAuth } from "../../context/AuthContext";
import './banner.css';


function Banner() {
    const [complete, setComplete] = useState(false);
    const [cdlis, setCdlis] = useState("");
    const [fcwd, setFcwd] = useState("");
    const [loading, setLoading] = useState(true);
    const [type, setType] = useState("m");
    const [system, setSystem] = useState("cdlis");
    const [message, setMessage] = useState();
    const [messages, setMessages] = useState([])
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [msgId, setMsgID] = useState();
    const [timeErr, setTimeErr] = useState("");
    const [currentView, setCurrentView] = useState("m");

    const navigate = useNavigate();

    const defined = (v) => v !== undefined && v !== null && v !== "";

    const { email, token } = useAuth();
    const today = new Date();
    const tabs = ["m","a"];

    const toEpoch = (d) => {
        return new Date(d).getTime();
    }

    useEffect(() => {    

        async function fetchData() {
            setLoading(true)
            try {
                const dbResponse = await fetch('/api/system/banner/getmessages/all', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );
                const ans = await dbResponse.json();
                if (!ans.success) {
                    throw new Error(ans.error || 'Failed to fetch');
                }
                setMessages(ans)
             if (!ans.status.success) throw new Error('Failed to fetch');
                 
            } catch (error) {
                console.error("Error fetching banner:", error);
            }
            setLoading(false);
        } fetchData();


    }, []);

    
    const doEdit = (e) => {
        
        const safelyFormatDate = (dateString) => {
            if (!dateString) return "";
            const dateObj = new Date(dateString);
            if (isNaN(dateObj.getTime())) return ""; 

            const tzOffset = dateObj.getTimezoneOffset() * 60000;
            const localDate = new Date(dateObj.getTime() - tzOffset);

            return localDate.toISOString().substring(0, 16);
        };

        setMessage(e?.message || "");
        setSystem(e?.system?.toLowerCase() || "");
        setType(e?.type?.toLowerCase() || "");
        setStart(safelyFormatDate(e?.from));
        setEnd(safelyFormatDate(e?.to));
        setMsgID(e?.id || "");
        
    }

    const submitMessage = async (e) =>{
        e.preventDefault();
        setLoading(true);
        if(!defined(system)){return}
        if(!defined(start)){
                setLoading(false);
                setTimeErr(<div style={{"color":"red"}}>Error: Start and End Dates Required</div>)
            return}
        if(!defined(end)){
                setLoading(false);
                setTimeErr(<div style={{"color":"red"}}>Error: Start and End Dates Required</div>)
            return}
        if(!defined(message)){return}
        if(!defined(type)){return}
        if(defined(start) && defined(end)){
            if(toEpoch(start) > toEpoch(end)){
                setLoading(false);
                setTimeErr(<div style={{"color":"red"}}>Error: Start is after End</div>)
                return
            }
        }

        const msgStr = message;
        if(msgStr.length > 2048){
            setLoading(false);
            setTimeErr(<div style={{"color":"red"}}>Error: Message Length too Long 2048 limit</div>);
            return
        }

        const UTC_start = new Date(start).toUTCString();
        const UTC_end = new Date(end).toUTCString();

         await fetch('/api/system/banner/addmessages', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ 
                "from": UTC_start,
                "to": UTC_end,
                "type": type,
                "system": system,
                "message": message,
                "uid": email,
                "date": today,
                "msgID": msgId
            })
        })
        .then(function (response) {
            setComplete(true);
            console.log("response received from status request", response);
            navigate(0);
        })
        .catch((error) => {
            console.error(error)
        })
        setLoading(false)
    }

    const toCaps = (s) => {
        if(s === "m") {return " Maintenance Messages"}
        if(s === "a") {return " Announcement Messages"}
    } 


    const formatDate = (d) => {
        return new Date(d).toLocaleString()
    }

    const sortTime = (v) => {
        //return v
        
        //return v.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        return [...v].sort((a, b) => {
            const dateB = b.date ? new Date(b.date).getTime() : 0;
            const dateA = a.date ? new Date(a.date).getTime() : 0;
            return dateB - dateA;
        });
        
    } 

 

    const doClear = () => {
        setMessage("");
        setSystem("cdlis");
        setStart(0);
        setEnd(0);
        setMsgID();
        setTimeErr("")
    }

    //alert(type)
    const MessageList = ({ data, onEdit, onDelete }) => {
        if (!data) return null; 

        //alert(system+ ": " + type) 
        

        let currentList = [];
        if((system === "cdlis") && (type === "m")){
            currentList = data?.responseData?.maintenance?.cdlis;
        }

        if((system === "fcwd") && (type === "m")){
            currentList = data?.responseData?.maintenance?.fcwd;
        }

        if((system === "cdlis") && (type === "a")){
            currentList = data?.responseData?.alert?.cdlis;
        }

        if((system === "fcwd") && (type === "a")){
            currentList = data?.responseData?.alert?.fcwd;
        }
        if (!currentList || !Array.isArray(currentList) || currentList.length === 0) {
            return <div className="mt-3 text-muted">No messages found.</div>;
        }
        const sorted = sortTime(currentList) 

        let dataArray = Array.isArray(sorted) ? sorted : [sorted];
        dataArray = dataArray.filter(v => v && v.id && v.message);
        if (dataArray.length === 0) return null;
        return (
            <div> 
            {sorted.map((v) => (
                <div id="banner">
                    <div style={{backgroundColor: "#bbbbbb"}}>
                        <center>
                        <strong>User Name:</strong>&nbsp;
                        {v.uid}&nbsp;&nbsp;
                        <strong>Date and Time: </strong>&nbsp;   
                        {formatDate(v.date)}  
                        </center>
                    </div>
                <div key={v.id} className="list-group-item d-flex align-items-center">
                    
                    <div style={{ display: "ruby-text" }} className="me-3">
                        {/* EDIT ICON */}
                        <button className="btn btn-outline-secondary btn-sm border-0" onClick={() => onEdit(v)}>
                            
                                                    
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                            </svg>
                        </button> 
                    </div>

                    <br />
                    <span className="text-secondary">{v.message} 
                    </span>
                    
                
                </div>
                </div>
            ))}
            </div>
        );
    };
    //date

     if(loading){
         return(<>
         <Loading />
         </>)
     }
    return(
        <>
        <div className='Index'>
            <div id='table' style={{width: '50', padding:'0px 30px 30px'}}>

                    <div id="banner-search">
                        <h4>Manage Messages</h4>
                        {defined(msgId) ? (
                            <>Editing...</>
                        ) : (<></>)}
                    </div>
                    <form onSubmit={submitMessage}>
            <div className="react-tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        defaultValue={"m"}
                        type="button"
                        onClick={() => {setCurrentView(tab); setType(tab); doClear()}}
                        className={`react-tab ${currentView === tab}`}
                    >
                    <span style={{ marginRight: "10px", fontSize: "22px" }}></span>
                    {toCaps(tab)}
                    </button>
                ))}

            </div>
                <strong>{toCaps(currentView)}</strong>
                <hr />
                    <table>
                        <tr>
                            <th>
                                <label className="form-label"> System</label>
                            </th>
                        </tr>
                        <tr>
                        <td>
                            <select
                                className="form-control" 
                                value={system}
                                onChange={(e) => setSystem(e.target.value)} required>
                                <option key="cdlis" value="cdlis">CDLIS</option>
                                <option key="fcwd" value="fcwd">FCWD</option>
                            </select>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label className="form-label">Start</label>
                            </th>
                            <th>
                                <label className="form-label">End</label>
                            </th>

                        </tr>
                        <tr>
                             <td>
                                <input 
                                className="form-control" 
                                type="datetime-local" 
                                value={start}
                                name="start"
                                onChange={(e) => setStart(e.target.value)}
                                />
                            </td>
                            <td>
                                <input 
                                className="form-control" 
                                value={end}
                                name="end"
                                onChange={(e) => setEnd(e.target.value)}
                                type="datetime-local" />
                            </td>
                            </tr>
                            <tr>
                             <td>
                                <div className="form-text mt-2 text-muted">
                                    Scheduled Outage Start.
                                </div>
                            </td>
                            <td>
                                <div className="form-text mt-2 text-muted">
                                    Scheduled Outage End. 
                                </div>
                            </td>

                        </tr>
                      
                    </table>
                    <div>
                        
                        <label className="form-label"><b><span className="text-danger">*</span> Message</b></label>
                    
                          <textarea 
                            className="form-control" 
                            rows="4" 
                            placeholder="Enter the message to be displayed... "
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            maxLength={2000}
                            required
                        ></textarea>
                        <div className="form-text mt-2 text-muted">
                            This the message text that will appear.
                        </div>
                        <button type="submit" className="btn btn-primary " id="button">
                            <i className="bi bi-broadcast"></i> Submit
                        </button>
                        <button type="button" className="btn btn-secondary" id="secondary-button"
                            onClick={doClear}
                        >
                            <i className="bi bi-broadcast"></i> Clear
                        </button>
                    </div>
                    </form>
                    <div className="list-group mt-4">
                        <MessageList data={messages} onEdit={doEdit} />
                    </div>
            </div>
            {complete && (
                <div className="alert alert-success" style={{marginTop: "20px"}}>
                    <h5 style={{color: "green"}}>Banners uploaded successfully!</h5>
                </div>
            )}
                
        </div>
        </>
    )
}

export default Banner;